<template>
	<div :class='novalide ? "v_radiogroup" : "v_radiogroup error"'>
		<!-- {{group}} -->

		<label v-for='inp in group' :class="inp.class">
			<input
				v-if='inp.check == "checked"'
				checked="checked"
				type="radio"
				:name='inp.name'
				:value='inp.value'
				v-model='checked'
				@change='noerror'
			/>
			<input
				v-else
				type="radio"
				:name='inp.name'
				:value='inp.value'
				v-model='checked'
				@change='noerror'
			/>
			<span class="radioLook"></span>
			<span class="text">{{inp.text}}</span>
		</label>
	</div>
</template>

<script>
const objectMerge = require('object-merge');
module.exports = {
	props: ['group', 'required'],

	data() {
		return {
			checked: '',
			name: '',
			novalide: true,
			check: {
				type: String
			}
		}
	},

	watch: {
		checked() {
			// console.log(this.$el.attributes.class.ownerDocument.activeElement.name);
			this.name = this.$el.attributes.class.ownerDocument.activeElement.name;
			this.$emit('RADIOGROUP_CHANGED', {
				[this.name]: this.checked
			});
		}
	},
	methods: {
		// если нажат чекбокс, убтраем ошибку валидации
		noerror() {
			let flag = false;
			for(let i = 0; i < this.$el.children.length; i++){
				if(this.$el.children[i].control.checked){
					this.novalide = true;
				}
			}
		},
		validate() {
			// перевірим, чи являється поле обов'язковим для заповнення

			// обов'язкове поле
			if(this.required) {
				let flag = false;
				for(let i = 0; i < this.$el.children.length; i++){
					if(this.$el.children[i].control.checked){
						flag = true;
					}
				}
				if(flag){
					this.valid = true;
					this.novalide = true;
				}else{
					this.valid = false;
					this.novalide = false;
				}
			}
			// не обов'язкове поле
			else {
				this.valid = true;
				this.novalide = true;
			}
		}
	},
	mounted() {
		let setChecked = () => {
			for(let i = 0; i < this.$el.children.length; i++){
				// console.log(this.$el.children[i].control.attributes.checked);
				if(this.$el.children[i].control.attributes.checked){
					setTimeout(() => {
						this.$el.children[i].control.click();
					}, 100);
				}
			}
		}
		setChecked();
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// radiogroup.vue?a92068a6